import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Pagination } from '../../../models/pagination';
import { ActivatedRoute } from '@angular/router';
import { CompaniesService } from '../../../services/companies.service';
import { PeopleService } from '../../../services/people.service';
import { LockTypes } from '../../../models/company-lock';
import { Person } from '../../../models/person';
import { InstanceTypes } from '../../../models/instance-types';

@Component({
  selector: 'app-people-list',
  templateUrl: './people-list.component.html',
  styleUrls: ['./people-list.component.css'],
  standalone: false
})
export class PeopleListComponent implements OnInit {
  public active: number = 2;
  clientCode: string;

  disableAddPersonButton: boolean;

  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }

  constructor(
    private authService: AuthService,
    private companyService: CompaniesService,
    private route: ActivatedRoute,
    private peopleService: PeopleService,
    @Inject('env') private env: any
  ) {}

  ngOnInit() {
    this.clientCode = this.route.snapshot.paramMap.get('client_code');
    if (this.clientCode == null) {
      this.clientCode = this.route.parent.snapshot.paramMap.get('client_code');
    }
    this.companyService.getLock(this.clientCode).subscribe(resp => {
      // task 9639. do not disable add person button
      // if the client is locked due to payroll in progress and
      // the logged in user is the one that holds the lock.
      const lockTypeMatch =
        resp?.Model?.LockType == LockTypes.Payroll ||
        resp?.Model?.LockType == LockTypes['Payroll Held'];

      if (lockTypeMatch && this.authService.isCurrentUser(resp?.Model?.LegacyUserId)) {
        return;
      }

      this.disableAddPersonButton = resp && resp.Model != null;
    });
  }
}
